import { UrlConstants } from "../url.constants";
export class ApiWayleaveConstants {
    static URL = UrlConstants.API_V2 + "Wayleave";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetWayleaveApplicantAndApplicantAgent";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateWayleaveInvoiceReport";
    static FUNCTION_SET_PROFESSIONAL_BODIES = "SetWayleaveProfessionalBodies";
    static FUNCTION_GET_WAYLEAVE_APPLICATIONS_BY_USER = "GetWApplicationsByUser";
    static FUNCTION_SET_LOCATION = "SetWayleaveLocation";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetWayleaveRequiredDocumentsChecklist";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
    static FUNCTION_VERIFY_RESUBMISSION_REFERENCE_NUMBER = "VerifyResubmissionReferenceNumber";
    static FUNCTION_APPLICATION_TYPES = "GetWApplicationTypes";
}
